export const common = {
  // Navigazione
  'nav.features': 'Funzionalità',
  'nav.howItWorks': 'Come funziona',
  'nav.pricing': 'Prezzi',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Chi Siamo',
  'nav.getStarted': 'Inizia',

  // Sezione Chi Siamo
  'aboutUs.badge': "Chi siamo",
  'aboutUs.title': "Perché esiste IdeaVerdict",
  'aboutUs.line1': "Chiunque può avere un'idea.",
  'aboutUs.line2': "Pochi ammettono che la loro non regge.",
  'aboutUs.paragraph1':
    "La maggior parte delle idee non fallisce per mancanza di coraggio. Fallisce perché nessuno ha detto la verità in tempo. IdeaVerdict colma questa lacuna — ti diamo il verdetto brutale che i tuoi amici non ti daranno.",
  'aboutUs.belief1a': "Non commerciamo in hype.",
  'aboutUs.belief1b': "Commerciamo in segnali di mercato.",
  'aboutUs.belief2a': "Non vendiamo motivazione.",
  'aboutUs.belief2b': "Vendiamo una lettura chiara di domanda, concorrenza e fattibilità.",
  'aboutUs.mission1': "Il nostro lavoro non è far sembrare buona la tua idea.",
  'aboutUs.mission2': "Il nostro lavoro è dirti se lo è.",
  'aboutUs.analysis':
    "IdeaVerdict valuta le idee su ciò che conta — struttura di mercato, domanda reale, concorrenza, capitale necessario, time-to-revenue, scalabilità. Nessuna emozione. Nessun ottimismo. Solo analisi.",
  'aboutUs.failure1': "La maggior parte delle aziende fallisce.",
  'aboutUs.failure2': "Non perché le persone dietro fossero incompetenti —",
  'aboutUs.failure3': "ma perché nessuno ha contro-argomentato abbastanza forte, in tempo.",
  'aboutUs.clarity': "Esistiamo per contro-argomentare.",
  'aboutUs.value1': "Diretto.",
  'aboutUs.value2': "Onesto.",
  'aboutUs.value3': "Veloce.",
  'aboutUs.confirm': "Se la tua idea ha sostanza, la sosteniamo.",
  'aboutUs.deny': "Se no, te lo diciamo in faccia.",
  'aboutUs.noApplause': "Nessun applauso.",
  'aboutUs.noSugarcoating': "Nessuno zucchero.",
  'aboutUs.noTheater': "Nessun teatro.",
  'aboutUs.noHype': "Solo il verdetto.",
  // Sezione Hero
  'hero.badge': 'Verdetto IA in meno di 60 secondi',
  'hero.title1': 'Non costruire',
  'hero.title2': 'prima di verificare.',
  'hero.subtitle': 'IdeaVerdict mette alla prova la tua idea come un VC scettico.',
  'hero.subtitleLine2': 'Verdetto onesto in secondi — niente hype, niente lusinghe.',
  'hero.cta': 'Ottieni il mio verdetto',
  'hero.ctaSecondary': 'Scopri come funziona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Crediti per richiesta',
  'hero.stat2Value': 'Da 7',
  'hero.stat2Label': 'Dimensioni di valutazione',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Onesto e Privato',

  // Sezione Funzionalità
  'features.title1': 'Costruito per',
  'features.title2': 'fondatori che',
  'features.title3': 'vogliono la verità',
  'features.bullet1.title': 'Verdetto onesto in pochi secondi',
  'features.bullet1.description':
    'Forte, Misto o Debole — con il ragionamento dietro. Niente applausi, niente edulcorazione, niente teatro.',
  'features.bullet2.title': 'Valutato su ciò che conta',
  'features.bullet2.description':
    'La tua idea viene valutata su domanda reale, concorrenza, capitale richiesto, tempo per generare ricavi e scalabilità — non sulle sensazioni.',
  'features.bullet3.title': 'Dal verdetto alla costruzione',
  'features.bullet3.description':
    'La modalità Builder trasforma un\'idea approvata in un brief per sviluppatori: user flow, funzionalità chiave, note tecniche.',

  // Come Funziona
  'howItWorks.title': 'Come funziona',
  'howItWorks.subtitle': 'Dall\'idea al verdetto — quattro passi, dieci minuti.',
  'howItWorks.step1Title': 'Scegli il piano',
  'howItWorks.step1Desc': 'Starter, Pro o Builder — scegli la profondità di analisi che ti serve.',
  'howItWorks.step2Title': 'Descrivi la tua idea',
  'howItWorks.step2Desc': 'Racconta all\'IA cosa stai costruendo. Ogni verdetto costa 30 crediti.',
  'howItWorks.step3Title': 'Ricevi il verdetto',
  'howItWorks.step3Desc': 'Tre valutazioni possibili: Forte, Misto o Debole. Con il ragionamento.',
  'howItWorks.step4Title': 'Decidi cosa fare',
  'howItWorks.step4Desc': 'Costruire, pivotare o lasciar perdere — con segnale reale, non istinto.',

  // Prezzi
  'pricing.title': 'Prezzi',
  'pricing.subtitle': 'Scegli il piano che si adatta alla profondità della tua analisi.',
  'pricing.monthly': 'Mensile',
  'pricing.yearly': 'Annuale',
  'pricing.yearlyDiscount': 'Abbonamento annuale:',
  'pricing.yearlyDiscountValue': '-20% di sconto',
  'pricing.perMonth': 'al mese',
  'pricing.selectPlan': 'Seleziona Piano',
  'pricing.mostPopular': 'Più Popolare',
  'pricing.footer':
    'Tutti i prezzi in CHF. I crediti vengono detratti solo per risposte AI riuscite.',

  // Pricing Features
  'pricing.feature1': 'Genera idea di nicchia',
  'pricing.feature2': 'Raffina nicchia',
  'pricing.feature3': 'Controllo di realtà del mercato',
  'pricing.feature4': 'Valutazione della concorrenza',
  'pricing.feature5': 'Valutazione del tempo',
  'pricing.feature6': 'Verdetto onesto',
  'pricing.feature7': 'Sessioni private',
  'pricing.feature8': 'Cronologia ed esportazione',
  'pricing.feature9': 'Idee di nicchia',
  'pricing.feature10': 'Analisi delle tendenze',
  'pricing.feature11': 'Suggerimenti per il miglioramento',
  'pricing.feature12': 'Nicchie alternative',
  'pricing.feature13': 'Analisi di mercato dettagliata',
  'pricing.feature14': 'Supporto prioritario',
  'pricing.feature15': 'Filtri avanzati',
  'pricing.feature16': 'Sessioni preferite',
  'pricing.feature17': 'Avvisi di Analisi',
  'pricing.feature18': 'Personal Success Manager',

  // Piano Starter
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Accesso al chatbot AI per nicchie',
  'pricing.starter.credits': '2.500 Crediti al mese',
  'pricing.starter.feature1': 'Genera idea di nicchia',
  'pricing.starter.feature2': 'Affina la nicchia',
  'pricing.starter.feature3': 'Verifica realistica del mercato',
  'pricing.starter.feature4': 'Valutazione della concorrenza',
  'pricing.starter.feature5': 'Valutazione dei tempi',
  'pricing.starter.feature6': 'Verdetto onesto',
  'pricing.starter.feature7': 'Sessioni private',
  'pricing.starter.feature8': 'Cronologia ed esportazione',

  // Piano Pro
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Accesso al chatbot AI per nicchie',
  'pricing.pro.credits': '5.000 Crediti al mese',
  'pricing.pro.feature1': 'Tutte le funzionalità Starter',
  'pricing.pro.feature2': 'Più crediti per analisi intensive',
  'pricing.pro.feature3': 'Suggerimenti per miglioramenti',
  'pricing.pro.feature4': 'Nicchie alternative',
  'pricing.pro.feature5': 'Analisi di mercato dettagliata',
  'pricing.pro.feature6': 'Supporto prioritario',
  'pricing.pro.feature7': 'Filtri avanzati',
  'pricing.pro.feature8': 'Sessioni preferite',

  // Piano Builder
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Tutte le funzioni + modalità Builder",
  'pricing.builder.credits': "10.000 crediti al mese",
  'pricing.builder.feature1': 'Tutte le funzionalità Pro',
  'pricing.builder.feature2': 'Richieste AI illimitate',
  'pricing.builder.feature3': 'Modalità Builder: briefing per sviluppatori',
  'pricing.builder.feature4': 'Panoramica progetto strutturata',
  'pricing.builder.feature5': 'Flussi utente e funzionalità principali',
  'pricing.builder.feature6': 'Note tecniche',
  'pricing.builder.feature7': 'Definisci i non-obiettivi',
  'pricing.builder.feature8': 'Limite di utilizzo equo',
  'pricing.builder.limitNote': 'Limite di utilizzo equo',
  'pricing.monthlyReset': 'Reset mensile',

  // Modale
  'pricing.modal.selected': 'selezionato',
  'pricing.modal.comingSoon':
    'Registrazione ed elaborazione dei pagamenti saranno disponibili a breve.',
  'pricing.modal.patience':
    'Stiamo lavorando per offrirti un\'esperienza sicura e senza intoppi. Ti chiediamo pazienza.',
  'pricing.modal.understood': 'Ho Capito',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Risposte dirette, niente marketing.',
  'faq.q1': "Cosa fa davvero IdeaVerdict?",
  'faq.a1': "Valuta la tua idea di business su ciò che decide il successo — domanda reale, concorrenza, capitale necessario, time-to-market, scalabilità.\nSe l'idea regge, ti mostriamo come affinarla.\nSe no, lo diciamo anche.",
  'faq.q2': "Generate anche idee?",
  'faq.a2': "Sì — ma non suggerimenti casuali.\nLe idee nascono da reali lacune di mercato, non da ciò che è di tendenza questa settimana.",
  'faq.q3': "Migliorate modelli di business esistenti?",
  'faq.a3': "Sì, se c'è qualcosa da migliorare.\nNon lucidiamo idee rotte — rafforziamo quelle che hanno già una base.",
  'faq.q4': "In cosa siete diversi dagli altri tool AI?",
  'faq.a4': "La maggior parte degli AI ti dice che la tua idea è fantastica.\nNoi ti diciamo se lo è davvero.\nLa differenza: realismo invece di entusiasmo.",
  'faq.q5': "Garantisce il successo?",
  'faq.a5': "No.\nTi aiutiamo a evitare scommesse cattive — il rischio non sparisce, ma entri con gli occhi aperti.",
  'faq.q6': "Per chi è IdeaVerdict?",
  'faq.a6': "Founder prima del lancio.\nBuilder prima del weekend side-project.\nOperator prima della prossima scommessa.\nInvestitori prima della firma.\n\nPer chiunque voglia chiarezza prima dell'impegno.",
  'faq.q7': "E se cerco solo conferma?",
  'faq.a7': "Allora IdeaVerdict è lo strumento sbagliato.\nForniamo verdetto onesto, non conforto.",
  'faq.q8': "Quanto è onesta davvero l'analisi?",
  'faq.a8': "Onesta quanto i dati permettono.\nNon ammorbidiamo un verdetto debole per risparmiare sentimenti.",
  'faq.q9': "Sostituisce una vera ricerca di mercato?",
  'faq.a9': "No.\nÈ un check strategico veloce prima dell'investimento — non uno studio di 50 pagine.",
  'faq.q10': "Perché così diretti?",
  'faq.a10': "Perché costruire la cosa sbagliata costa mesi.\nUn verdetto onesto costa minuti.\n\nScegliamo i minuti.",
  // Footer
  'footer.description':
    'IdeaVerdict non esiste per farti sentire bene. Esiste per aiutarti a decidere bene.',
  'footer.product': 'Prodotto',
  'footer.aiAssistant': 'Assistente AI',
  'footer.howItWorks': 'Come funziona',
  'footer.pricing': 'Prezzi',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legale',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Termini',
  'footer.imprint': 'Note Legali',
  'footer.support': 'Supporto',
  'footer.contact': 'Contatti',
  'footer.documentation': 'Documentazione',
  'footer.copyright': '© 2026 IdeaVerdict. Tutti i diritti riservati.',

  // Assistente AI
  'aiAssistant.title': 'Assistente AI per Nicchie',
  'aiAssistant.subtitle': 'Chiedi informazioni sulle nicchie',
  'aiAssistant.welcomeMessage':
    'Ciao! Descrivi la tua idea o chiedimi informazioni su una nicchia. Ti darò una valutazione chiara e onesta.',
  'aiAssistant.demoResponse':
    'Questa è una demo. Per ricevere valutazioni AI reali, registrati e scegli un piano.',
  'aiAssistant.placeholder': 'Descrivi la tua idea...',

  // Header e Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.aiAssistant': 'Il tuo Assistente AI',
  'header.logout': 'Esci',
  'dashboard.sidebar.overview': 'Panoramica',
  'dashboard.sidebar.aiChat': 'Assistente AI',
  'dashboard.sidebar.newAnalysis': 'Assistente AI',
  'dashboard.sidebar.history': 'Cronologia',
  'dashboard.sidebar.credits': 'Crediti',
  'dashboard.sidebar.settings': 'Impostazioni',

  // Panoramica Dashboard
  'dashboard.overview.welcome': 'Bentornato, {{name}}',
  'dashboard.overview.subtitle':
    'Ecco una rapida panoramica della tua attività',

  // Statistiche Dashboard
  'dashboard.stats.creditsRemaining': 'Crediti rimanenti',
  'dashboard.stats.totalAnalyses': 'Analisi totali',
  'dashboard.stats.goodRatings': 'Valutazioni positive',
  'dashboard.stats.nextReset': 'Prossimo reset tra',
  'dashboard.stats.days': 'giorni',

  // Azioni Rapide
  'dashboard.quickActions.title': 'Azioni rapide',
  'dashboard.quickActions.checkNewIdea': 'Valuta un\'idea',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analizza un\'idea di business esistente',
  'dashboard.quickActions.generateIdea': 'Genera un\'idea',
  'dashboard.quickActions.generateIdeaDesc':
    'Trova una nuova nicchia redditizia',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Trasforma un\'idea in un briefing pronto per gli sviluppatori',
  'dashboard.quickActions.premiumOnly': 'Solo Builder',

  // Intestazione Chat
  'chat.title': 'Assistente AI per Nicchie',
  'chat.subtitle':
    'Fai domande sulle nicchie. Valuto in modo critico e onesto.',
  'chat.creditsLabel': 'Crediti',

  // Benvenuto Chat
  'chat.welcomeTitle': 'Benvenuto nell\'Assistente AI per Nicchie',
  'chat.welcomeDesc':
    'Descrivi la tua idea o chiedi informazioni su una nicchia. La valuterò onestamente: Buono, Medio o Scarso.',
  'chat.aiWelcome':
    'Ciao! Descrivi la tua idea o chiedimi informazioni su una nicchia. Ti darò una valutazione chiara e onesta.',

  // Suggerimenti Chat
  'chat.suggestion1': 'Voglio creare un tool SaaS per freelancer per gestire le fatture. È una buona nicchia?',
  'chat.suggestion2': 'Trovami un business online con poca concorrenza che posso avviare con $500 senza saper programmare.',
  'chat.suggestion3': 'Valuta questo: un\'app di pianificazione pasti con IA per genitori impegnati con restrizioni alimentari.',
  'chat.suggestion4': 'Voglio vendere template digitali su Etsy per piccoli imprenditori. Analizza questa nicchia onestamente.',

  // Azioni Chat
  'chat.newConversation': 'Nuova conversazione',
  'chat.today': 'Oggi',
  'chat.yesterday': 'Ieri',
  'chat.thisWeek': 'Questa settimana',
  'chat.thisMonth': 'Questo mese',
  'chat.older': 'Precedenti',
  'chat.messages': 'messaggi',
  'chat.renameConversation': 'Rinomina',
  'chat.deleteConversation': 'Elimina',
  'chat.cancel': 'Annulla',
  'chat.rename': 'Rinomina',
  'chat.delete': 'Elimina',
  'chat.favorite': 'Aggiungi ai preferiti',
  'chat.unfavorite': 'Rimuovi dai preferiti',
  'chat.searchSessions': 'Cerca conversazioni...',
  'chat.noResults': 'Nessun risultato trovato',
  'chat.noSessions': 'Ancora nessuna conversazione',
  'chat.enterNewName': 'Inserisci un nuovo nome...',
  'chat.deleteConfirmMessage':
    'Sei sicuro di voler eliminare questa conversazione? Questa azione non può essere annullata.',

  // Input Chat ed Errori
  'chat.inputPlaceholder': 'Scrivi la tua domanda… (costa 30 crediti)',
  'chat.send': 'Invia',
  'chat.voice': 'Parla',
  'chat.listeningPlaceholder': 'Sto ascoltando... Parla ora.',
  'chat.stopListening': 'Smetti di ascoltare',
  'chat.recording': 'Registrazione...',
  'chat.speechNotSupported': 'Il tuo browser non supporta il riconoscimento vocale.',
  'chat.microphonePermissionDenied': 'Accesso al microfono negato. Per favore, concedi l\'accesso nelle impostazioni del browser.',
  'chat.errorNotEnoughCredits':
    'Crediti insufficienti. Per favore, aggiorna il tuo piano o attendi il prossimo reset.',
  'chat.errorAiFailed': 'Risposta AI fallita. Nessun credito è stato detratto.',
  'chat.errorRateLimit': 'Troppe richieste. Per favore, attendi un momento.',

  // Valutazioni
  'rating.good': 'Buono',
  'rating.medium': 'Medio',
  'rating.bad': 'Scarso',

  // Pagina Auth
  'auth.branding.headline1': 'Non tutte le idee sono buone.',
  'auth.branding.headline2': 'Te lo diciamo onestamente.',
  'auth.branding.subtitle':
    'Un\'AI decisionale per nicchie di business. Chiara. Critica. Niente zucchero.',
  'auth.benefits.privacy.title': '100% Privato',
  'auth.benefits.privacy.desc':
    'Le tue idee rimangono completamente private e sicure.',
  'auth.benefits.honest.title': 'AI Onesta',
  'auth.benefits.honest.desc':
    'Niente zucchero – solo feedback chiaro e critico.',
  'auth.benefits.fast.title': 'Risultati Veloci',
  'auth.benefits.fast.desc': 'Ottieni chiarezza sulla tua nicchia in minuti.',
  'auth.trust.users': 'Utenti Attivi',
  'auth.trust.ideas': 'Idee Analizzate',
  'auth.trust.rating': 'Valutazione Utenti',
  'auth.login.title': 'Accesso',
  'auth.login.headline': 'Bentornato',
  'auth.login.subtitle': 'Accedi per continuare il tuo viaggio.',
  'auth.login.forgotPassword': 'Password dimenticata?',
  'auth.login.submit': 'Accedi',
  'auth.login.noAccount': 'Non hai un account?',
  'auth.login.signUp': 'Registrati',
  'auth.register.title': 'Registrazione',
  'auth.register.headline': 'Crea il tuo account',
  'auth.register.subtitle':
    'Inizia ad analizzare le tue idee di business oggi stesso.',
  'auth.register.submit': 'Crea Account',
  'auth.register.hasAccount': 'Hai già un account?',
  'auth.register.signIn': 'Accedi',
  'auth.fields.name': 'Nome Completo',
  'auth.fields.email': 'Indirizzo Email',
  'auth.fields.password': 'Password',
  'auth.fields.confirmPassword': 'Conferma Password',
  'auth.fields.selectPlan': 'Seleziona il tuo piano',
  'auth.fields.testCode': 'Accedi e prova gratuitamente',
  'auth.placeholders.name': 'Inserisci il tuo nome',
  'auth.placeholders.email': 'Inserisci la tua email',
  'auth.placeholders.password': 'Inserisci la tua password',
  'auth.placeholders.confirmPassword': 'Conferma la tua password',
  'auth.placeholders.testCode': 'Inserisci il codice di prova',
  'auth.terms.accept': 'Accetto i',
  'auth.terms.terms': 'Termini e Condizioni',
  'auth.privacy.accept': 'Accetto la',
  'auth.privacy.policy': 'Informativa sulla Privacy',
  'auth.errors.nameRequired': 'Il nome è obbligatorio',
  'auth.errors.emailRequired': 'L\'email è obbligatoria',
  'auth.errors.emailInvalid': 'Inserisci un\'email valida',
  'auth.errors.passwordRequired': 'La password è obbligatoria',
  'auth.errors.passwordLength': 'La password deve essere di almeno 8 caratteri',
  'auth.errors.passwordMismatch': 'Le password non corrispondono',
  'auth.errors.invalidCode': 'Codice non valido o scaduto',
  'auth.errors.registrationCodeOnly': 'Questo codice è solo per la registrazione',
  'auth.errors.verificationFailed': 'Errore nella verifica del codice. Riprova.',
  'auth.loading': 'Attendi...',
  'auth.or': 'oppure continua con',
  'auth.social.google': 'Continua con Google',
  'auth.social.apple': 'Continua con Apple',
  'auth.actions.verify': 'Verifica',
  'auth.testCode.activated': 'Codice di prova attivato!',
  'auth.testCode.days': 'giorni',
  'auth.testCode.months': 'mesi',
  'auth.testCode.freeAccess': 'accesso gratuito',
  'auth.testCode.credits': 'crediti',

  // Verifica Email
  'auth.verification.title': 'Verifica Email',
  'auth.verification.headline': 'Controlla la tua casella di posta',
  'auth.verification.subtitle': 'Abbiamo inviato un codice di verifica a:',
  'auth.verification.codeLabel': 'Codice di Verifica',
  'auth.verification.codePlaceholder': 'Inserisci il codice a 6 cifre',
  'auth.verification.submit': 'Verifica Email',
  'auth.verification.resend': 'Invia nuovamente il codice',
  'auth.verification.resendIn': 'Invia tra',
  'auth.verification.seconds': 'secondi',
  'auth.verification.success': 'Email verificata con successo!',
  'auth.verification.error': 'Codice non valido. Riprova.',
  'auth.verification.expired': 'Codice scaduto. Richiedine uno nuovo.',
  'auth.verification.sent': 'Nuovo codice inviato!',
  'auth.verification.checkSpam':
    'Non lo hai ricevuto? Controlla la cartella dello spam.',

  // Password Dimenticata
  'auth.forgot.title': 'Password Dimenticata',
  'auth.forgot.headline': 'Reimposta la tua password',
  'auth.forgot.subtitle':
    'Inserisci il tuo indirizzo email e ti invieremo un link per reimpostarla.',
  'auth.forgot.submit': 'Invia Link di Reimpostazione',
  'auth.forgot.backToLogin': 'Torna al login',
  'auth.forgot.success': 'Email inviata!',
  'auth.forgot.successMessage':
    'Ti abbiamo inviato un\'email con le istruzioni per reimpostare la tua password.',
  'auth.forgot.checkInbox': 'Controlla la tua casella di posta',

  // Reimpostazione Password
  'auth.reset.title': 'Nuova Password',
  'auth.reset.headline': 'Imposta nuova password',
  'auth.reset.subtitle': 'Inserisci la tua nuova password.',
  'auth.reset.newPassword': 'Nuova Password',
  'auth.reset.confirmNewPassword': 'Conferma Nuova Password',
  'auth.reset.submit': 'Cambia Password',
  'auth.reset.success': 'Password cambiata con successo!',
  'auth.reset.successMessage':
    'Ora puoi accedere con la tua nuova password.',
  'auth.reset.loginNow': 'Accedi ora',

  // Pagine Legali
  'legal.backToAuth': 'Torna al login',
  'legal.allRightsReserved': 'Tutti i diritti riservati.',

  // Pagina Termini
  'legal.terms.title': 'Termini e Condizioni',
  'legal.terms.lastUpdated': 'Ultimo aggiornamento',
  'legal.terms.section1.title': '1. Ambito di applicazione',
  'legal.terms.section1.content':
    'Questi Termini e Condizioni si applicano a tutti i contratti tra NicheFinder (di seguito "Fornitore") e l\'utente (di seguito "Cliente") riguardanti l\'uso della piattaforma di analisi di nicchia basata sull\'IA.',
  'legal.terms.section2.title': '2. Descrizione del Servizio',
  'legal.terms.section2.content':
    'Il Fornitore offre una piattaforma basata sull\'IA che analizza e valuta idee e nicchie di business. I servizi includono:',
  'legal.terms.section2.item1': 'Analisi basata sull\'IA di idee imprenditoriali',
  'legal.terms.section2.item2': 'Valutazione del potenziale di mercato e della concorrenza',
  'legal.terms.section2.item3': 'Generazione di suggerimenti per nicchie',
  'legal.terms.section2.item4': 'Creazione di briefing per sviluppatori (pacchetto Builder)',
  'legal.terms.section3.title': '3. Conclusione del Contratto e Registrazione',
  'legal.terms.section3.content':
    'Il contratto si conclude con la registrazione sulla piattaforma e la selezione di un pacchetto. Il cliente conferma:',
  'legal.terms.section3.item1': 'Di essere maggiorenne e pienamente capace di agire',
  'legal.terms.section3.item2': 'Di fornire informazioni veritiere durante la registrazione',
  'legal.terms.section3.item3': 'Di conservare in modo sicuro le credenziali di accesso',
  'legal.terms.section4.title': '4. Crediti e Fatturazione',
  'legal.terms.section4.content':
    'L\'uso delle funzionalità AI si basa su un sistema di crediti. Ogni richiesta AI costa 30 crediti. I crediti vengono detratti solo in caso di risposta riuscita. I crediti non utilizzati scadono alla fine del periodo di fatturazione e non vengono rimborsati.',
  'legal.terms.section5.title': '5. Esclusione di responsabilità',
  'legal.terms.section5.content':
    'Le valutazioni dell\'IA servono esclusivamente come aiuto decisionale e non garantiscono il successo dell\'impresa. Il Fornitore non è responsabile per le decisioni prese sulla base delle analisi dell\'IA. La responsabilità per dolo e colpa grave rimane invariata.',
  'legal.terms.section6.title': '6. Protezione dei Dati e Riservatezza',
  'legal.terms.section6.content':
    'Tutte le idee imprenditoriali presentate sono trattate in modo confidenziale e non vengono condivise con terzi. Il trattamento dei dati personali viene effettuato in conformità con la nostra Informativa sulla Privacy e le leggi applicabili sulla protezione dei dati.',
  'legal.terms.section7.title': '7. Recesso',
  'legal.terms.section7.content':
    'Il cliente può disdire il proprio abbonamento in qualsiasi momento con effetto alla fine del periodo di fatturazione corrente. In caso di violazione dei presenti Termini, il Fornitore si riserva il diritto di bloccare l\'accesso alla piattaforma.',
  'legal.terms.section8.title': '8. Disposizioni Finali',
  'legal.terms.section8.content':
    'Si applica la legge svizzera. Il foro competente è Zurigo, Svizzera. Se singole disposizioni dei presenti Termini dovessero essere invalide, la validità delle restanti disposizioni rimane invariata.',
  'legal.terms.contact.title': 'Domande sui Termini?',
  'legal.terms.contact.content':
    'Se hai domande su questi Termini e Condizioni, contattaci a:',

  // Pagina Privacy
  'legal.privacy.title': 'Informativa sulla Privacy',
  'legal.privacy.section1.title': '1. Titolare del Trattamento',
  'legal.privacy.section1.content':
    'Il titolare del trattamento per questo sito web è NicheFinder, Zurigo, Svizzera. Prendiamo molto sul serio la protezione dei tuoi dati personali e trattiamo i tuoi dati personali in modo riservato e in conformità con le normative legali sulla protezione dei dati.',
  'legal.privacy.section2.title': '2. Dati raccolti',
  'legal.privacy.section2.content':
    'Raccogliamo e trattiamo i seguenti dati personali:',
  'legal.privacy.section2.item1':
    'Dati di registrazione: Nome, indirizzo email, password (criptata)',
  'legal.privacy.section2.item2':
    'Dati di utilizzo: Indirizzo IP, tipo di browser, orari di accesso',
  'legal.privacy.section2.item3':
    'Idee imprenditoriali e query di nicchia (memorizzate in forma anonima)',
  'legal.privacy.section2.item4':
    'Informazioni di pagamento (tramite fornitori terzi sicuri)',
  'legal.privacy.section3.title': '3. Finalità del Trattamento dei Dati',
  'legal.privacy.section3.content':
    'I tuoi dati vengono utilizzati per le seguenti finalità:',
  'legal.privacy.section3.item1':
    'Fornitura e miglioramento dei nostri servizi AI',
  'legal.privacy.section3.item2':
    'Gestione dell\'account e autenticazione',
  'legal.privacy.section3.item3':
    'Fatturazione ed elaborazione dei pagamenti',
  'legal.privacy.section4.title': '4. Sicurezza dei Dati',
  'legal.privacy.section4.content':
    'Implementiamo misure di sicurezza tecniche e organizzative per proteggere i tuoi dati da manipolazione, perdita, distruzione o accesso non autorizzato. Tutti i trasferimenti di dati sono crittografati tramite SSL/TLS.',
  'legal.privacy.section5.title': '5. Riservatezza delle Tue Idee Imprenditoriali',
  'legal.privacy.section5.content':
    'Le tue idee imprenditoriali e le query di nicchia sono trattate in stretta riservatezza. Non vengono condivise con terzi, non vengono utilizzate per scopi di addestramento e possono essere completamente cancellate su richiesta. Le tue idee ti appartengono.',
  'legal.privacy.section6.title': '6. I Tuoi Diritti',
  'legal.privacy.section6.content':
    'Hai i seguenti diritti riguardo ai tuoi dati personali:',
  'legal.privacy.section6.item1': 'Diritto di accesso ai dati memorizzati',
  'legal.privacy.section6.item2': 'Diritto di rettifica di dati inesatti',
  'legal.privacy.section6.item3': 'Diritto alla cancellazione dei tuoi dati',
  'legal.privacy.section6.item4': 'Diritto alla portabilità dei dati',
  'legal.privacy.section7.title': '7. Cookie',
  'legal.privacy.section7.content':
    'Il nostro sito web utilizza solo cookie tecnicamente necessari per l\'autenticazione e la gestione della sessione. Non utilizziamo cookie di tracciamento o strumenti di analisi di terze parti senza il tuo consenso esplicito.',
  'legal.privacy.section8.title': '8. Modifiche a questa Informativa sulla Privacy',
  'legal.privacy.section8.content':
    'Ci riserviamo il diritto di adattare questa informativa sulla privacy per conformarci ai requisiti legali modificati o quando vengono apportate modifiche al servizio. La versione corrente è sempre disponibile su questa pagina.',
  'legal.privacy.contact.title': 'Domande sulla Privacy?',
  'legal.privacy.contact.content':
    'Se hai domande sul trattamento dei tuoi dati personali, contattaci a:',

  'auth.passwordStrength.label': 'Robustezza password',
  'auth.passwordStrength.weak': 'Debole',
  'auth.passwordStrength.medium': 'Media',
  'auth.passwordStrength.strong': 'Forte',
  'auth.passwordStrength.veryStrong': 'Molto forte',
  'auth.passwordStrength.minLength': 'Min. 8 caratteri',
  'auth.passwordStrength.uppercase': 'Maiuscola',
  'auth.passwordStrength.number': 'Numero',
  'auth.passwordStrength.special': 'Carattere speciale',

  trial: {
    subtitle: 'Prova Gratuita',
    upgrade: 'Aggiorna Ora',
    creditsRemaining: 'crediti rimanenti',
    inputHint: 'Versione di prova - Nessuna cronologia conversazioni disponibile',
    banner: {
      title: 'Prova di 7 Giorni Attiva',
      remaining: '{{days}} giorni rimanenti',
      credits: 'crediti disponibili',
      upgradeNow: 'Aggiorna Ora',
    },
    welcome: {
      title: 'Benvenuto nella Prova Gratuita!',
      desc: 'Prova il nostro assistente AI gratuitamente per 7 giorni con 100 crediti. Fai domande e scopri le possibilità!',
    },
    info: {
      title: 'Limitazioni della Prova',
      credits: '100 crediti per 7 giorni',
      noHistory: 'Nessuna cronologia conversazioni',
      noSettings: 'Funzionalità limitate',
      upgrade: 'Aggiorna per tutte le funzionalità',
    },
  },

  // ─── Pagina Impostazioni ────────────────────────────────────────────────────────────
  'settings.title': 'Impostazioni',
  'settings.subtitle': 'Gestisci il tuo account e le preferenze',
  'settings.backToOverview': 'Torna alla panoramica',
  'settings.subscriptionLink': 'Abbonamento e Fatturazione',
  'settings.saved': 'Modifiche salvate con successo',
  'settings.changesSaved': 'Modifiche salvate',
  'settings.saveChanges': 'Salva modifiche',
  'settings.dataExported': 'Dati esportati con successo',

  // Schede
  'settings.tabs.profile': 'Profilo',
  'settings.tabs.preferences': 'Preferenze',
  'settings.tabs.notifications': 'Notifiche',
  'settings.tabs.account': 'Account e Piano',

  // Profilo
  'settings.profile.changePhoto': 'Cambia foto',
  'settings.profile.photoHint': 'JPG, PNG o GIF (max. 2MB)',
  'settings.profile.uploading': 'Caricamento...',
  'settings.profile.photoUpdated': 'Foto del profilo aggiornata!',
  'settings.profile.name': 'Nome',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Telefono',
  'settings.profile.changePassword': 'Cambia password',
  'settings.profile.currentPassword': 'Password attuale',
  'settings.profile.newPassword': 'Nuova password',
  'settings.profile.confirmPassword': 'Conferma password',

  // Preferenze
  'settings.preferences.language': 'Lingua',
  'settings.preferences.chooseLanguage': 'Scegli lingua',
  'settings.preferences.timezone': 'Fuso orario',
  'settings.preferences.currency': 'Valuta',

  // Notifiche
  'settings.notifications.emailTitle': 'Notifiche Email',
  'settings.notifications.email.analysis': 'Analisi completata',
  'settings.notifications.email.analysisDesc': 'Ricevi un\'email quando la tua analisi è pronta',
  'settings.notifications.email.credits': 'Aggiornamenti crediti',
  'settings.notifications.email.creditsDesc': 'Notifiche su crediti e resettaggi',
  'settings.notifications.email.billing': 'Fatture e Pagamenti',
  'settings.notifications.email.billingDesc': 'Notifiche su fatture e modifiche al piano',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Suggerimenti, aggiornamenti e nuove funzionalità',
  'settings.notifications.pushTitle': 'Notifiche Push',
  'settings.notifications.push.analysis': 'Analisi completata',
  'settings.notifications.push.analysisDesc': 'Notifica browser quando l\'analisi è pronta',
  'settings.notifications.push.credits': 'Avvisi crediti',
  'settings.notifications.push.creditsDesc': 'Avviso quando il credito residuo è basso',

  // Account
  'settings.account.currentSubscription': 'Abbonamento Attuale',
  'settings.account.plan': 'Piano',
  'settings.account.price': 'Prezzo',
  'settings.account.nextBilling': 'Prossima fatturazione',
  'settings.account.manageSubscription': 'Gestisci abbonamento e pagamenti',
  'settings.account.dataPrivacy': 'Dati e Privacy',
  'settings.account.exportData': 'Esporta dati',
  'settings.account.deleteAccount': 'Elimina account',

  // Modale Eliminazione
  'settings.deleteModal.title': 'Eliminare l\'account?',
  'settings.deleteModal.subtitle': 'Tutti i dati verranno cancellati permanentemente.',
  'settings.deleteModal.warning1': 'Tutte le analisi e i dati verranno eliminati',
  'settings.deleteModal.warning2': 'L\'abbonamento attivo verrà cancellato immediatamente',
  'settings.deleteModal.warning3': 'Nessun rimborso possibile',
  'settings.deleteModal.confirmLabel': 'Digita "{{word}}" per confermare *',
  'settings.deleteModal.cancel': 'Annulla',
  'settings.deleteModal.confirm': 'Elimina account',

  // ─── Abbonamento e Fatturazione ─────────────────────────────────────────────
  'sub.backToOverview': 'Torna alla panoramica',
  'sub.settings': 'Impostazioni',
  'sub.title': 'Abbonamento e Fatturazione',
  'sub.subtitle': 'Gestisci il tuo abbonamento, i metodi di pagamento e le fatture',
  'sub.tab.overview': 'Panoramica',
  'sub.tab.payment': 'Metodi di Pagamento',
  'sub.tab.billing': 'Indirizzo di Fatturazione',
  'sub.tab.history': 'Cronologia Pagamenti',
  'sub.memberSince': 'Membro dal',
  'sub.perMonth': 'al mese',
  'sub.baseCHF': '(CHF {{amount}} base)',
  'sub.nextBilling': 'Prossima fatturazione',
  'sub.creditsUsed': 'Crediti utilizzati',
  'sub.paymentMethod': 'Metodo di pagamento',
  'sub.creditUsage': 'Utilizzo crediti',
  'sub.changePlan': 'Cambia piano',
  'sub.reactivate': 'Riattiva',
  'sub.cancelSub': 'Cancella abbonamento',
  'sub.manageCards': 'Gestisci carte',
  'sub.downloadInvoices': 'Scarica fatture',
  'sub.invoicesAvailable': '{{count}} fatture disponibili come PDF',
  'sub.accountSettings': 'Impostazioni Account',
  'sub.profileNotifications': 'Profilo, notifiche e altro',
  // Info prezzi in EUR
  'sub.eurInfo': 'Prezzi mostrati in',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Tasso:',
  'sub.currentRate': 'Tasso attuale',
  // Metodi di Pagamento
  'sub.savedCards': 'Carte Salvate',
  'sub.newCard': 'Nuova Carta',
  'sub.default': 'Predefinita',
  'sub.setDefault': 'Imposta come predefinita',
  'sub.validUntil': 'Valida fino al',
  'sub.noCards': 'Nessuna carta salvata',
  'sub.addFirstCard': 'Aggiungi la prima carta',
  'sub.securePayments': 'Pagamenti Sicuri',
  'sub.securePaymentsDesc': 'Tutti i dati di pagamento vengono trasmessi criptati e memorizzati in modo sicuro con il nostro fornitore di pagamento. Non memorizziamo numeri di carta completi.',
  // Indirizzo di Fatturazione
  'sub.billingAddress': 'Indirizzo di Fatturazione',
  'sub.edit': 'Modifica',
  'sub.name': 'Nome',
  'sub.streetAddress': 'Via e Numero',
  'sub.zip': 'CAP',
  'sub.city': 'Città',
  'sub.country': 'Paese',
  'sub.address': 'Indirizzo',
  'sub.save': 'Salva',
  'sub.cancel': 'Annulla',
  'sub.country.switzerland': 'Svizzera',
  'sub.country.germany': 'Germania',
  'sub.country.austria': 'Austria',
  'sub.country.netherlands': 'Paesi Bassi',
  'sub.country.belgium': 'Belgio',
  // Cronologia Pagamenti
  'sub.paymentHistory': 'Cronologia Pagamenti',
  'sub.allInvoicesPDF': 'Scarica tutte le fatture come PDF con logo',
  'sub.downloadAll': 'Scarica tutto',
  'sub.eurInvoiceNote': 'Le fatture sono sempre emesse in CHF. Gli importi in EUR mostrati sono solo di riferimento.',
  'sub.date': 'Data',
  'sub.description': 'Descrizione',
  'sub.net': 'Netto',
  'sub.vat': 'IVA',
  'sub.total': 'Totale',
  'sub.status': 'Stato',
  'sub.pdf': 'PDF',
  'sub.invoices': 'fatture',
  'sub.totalAmount': 'Importo totale',
  // Modale Cambio Piano
  'sub.changePlanTitle': 'Cambia Piano',
  'sub.current': 'Attuale',
  'sub.month': '/mese',
  'sub.showLess': 'Mostra meno',
  'sub.showMore': '+{{count}} altro',
  'sub.switchPlan': 'Cambia piano',
  'sub.eurPriceNote': 'Prezzi mostrati in EUR ({{note}}). La fatturazione è in CHF.',
  // Modale Cancellazione
  'sub.cancelTitle': 'Cancellare davvero l\'abbonamento?',
  'sub.cancelIrreversible': 'Questa azione non può essere annullata.',
  'sub.cancelWarning1': 'Tutti i crediti rimanenti scadranno',
  'sub.cancelWarning2': 'Passaggio al Piano Gratuito',
  'sub.cancelWarning3': 'Perdita di tutte le funzionalità premium',
  'sub.pauseInstead': 'In alternativa: Mettere in pausa l\'abbonamento?',
  'sub.pauseDesc': 'Metti in pausa il tuo abbonamento e mantieni i tuoi dati.',
  'sub.preferPause': 'Preferisci mettere in pausa',
  'sub.cancelReason': 'Motivo della cancellazione',
  'sub.selectReason': 'Seleziona...',
  'sub.reason.tooExpensive': 'Troppo costoso',
  'sub.reason.notUsing': 'Non lo uso abbastanza',
  'sub.reason.missingFeatures': 'Funzionalità mancanti',
  'sub.reason.foundAlternative': 'Trovata un\'alternativa',
  'sub.reason.other': 'Altro',
  'sub.confirmType': 'Conferma: Digita "CANCEL" *',
  'sub.cancelNow': 'Cancella ora',
  // Modale Aggiungi Carta
  'sub.addCardTitle': 'Aggiungi Nuova Carta',
  'sub.cardHolder': 'Intestatario Carta *',
  'sub.cardNumber': 'Numero Carta *',
  'sub.expiryDate': 'Data di Scadenza *',
  'sub.addCard': 'Aggiungi carta',
  // Modale Cambio Carta
  'sub.choosePayment': 'Scegli metodo di pagamento',
  'sub.active': 'Attivo',
  'sub.close': 'Chiudi',
  // Messaggi Toast
  'sub.toast.cancelled': 'Il tuo abbonamento è stato cancellato alla fine del periodo di fatturazione.',
  'sub.toast.reactivated': 'Il tuo abbonamento è stato riattivato con successo!',
  'sub.toast.planChanged': 'Piano cambiato con successo in {{plan}}!',
  'sub.toast.defaultChanged': 'Metodo di pagamento predefinito cambiato.',
  'sub.toast.cannotDeleteDefault': 'La carta predefinita non può essere eliminata.',
  'sub.toast.cardRemoved': 'La carta è stata rimossa.',
  'sub.toast.fillAll': 'Compila tutti i campi.',
  'sub.toast.cardAdded': 'Nuova carta aggiunta con successo!',
  'sub.toast.billingSaved': 'Indirizzo di fatturazione salvato.',
  'sub.toast.invoiceDownloaded': 'Fattura {{id}} scaricata!',
  'sub.toast.pdfError': 'Errore durante la creazione del PDF.',
  // Interfaccia chat
  'sub.notEnoughCredits': 'Crediti insufficienti',
  'sub.needCredits': 'Hai bisogno di almeno {{count}} crediti per domanda.',
  'sub.creditsLow': 'Crediti in esaurimento',
  'sub.questionsLeft': '{{count}} domande possibili.',
  'sub.plan': 'Piano',
  'sub.base': 'base',
  'sub.unlimited': 'Illimitato',
  'sub.status.active': 'Attivo',
  'sub.status.cancelled': 'Cancellato',
  'sub.status.paused': 'In pausa',
  'sub.invoice': 'FATTURA',
  'sub.from': 'DA',
  'sub.to': 'A',
  'sub.vatId': 'Partita IVA',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Data fattura',
  'sub.invoiceNumber': 'Numero fattura',
  'sub.paymentStatus': 'Stato pagamento',
  'sub.creditCard': 'Carta di credito',
  'sub.quantity': 'Q.TÀ',
  'sub.price': 'PREZZO',
  'sub.amount': 'IMPORTO',
  'sub.subtotal': 'Subtotale',
  'sub.bank': 'Banca',
  'sub.card': 'Carta',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Mario Rossi',

  // ─── Pannello Admin ─────────────────────────────────────────────────────────────
  'admin.title': 'Dashboard Admin',
  'admin.subtitle': 'Centro di Controllo',
  'admin.superAdmin': 'Super Admin',
  'admin.logout': 'Esci',
  'admin.tabs.users': 'Gestione Utenti',
  'admin.tabs.downgrades': 'Declassamenti',
  'admin.tabs.tips': 'Suggerimento del Giorno',
  'admin.tabs.coupons': 'Codici Promozionali',
  'admin.tabs.website': 'Editor Sito Web',
  'admin.tabs.ai': 'Impostazioni AI',
  'admin.tabs.transactions': 'Registro Transazioni',
  'admin.tabs.stats': 'Statistiche',
  'admin.users.searchPlaceholder': 'Cerca utenti (email o nome)...',
  'admin.users.manageSubscription': 'Gestisci abbonamento',
  'admin.users.grantFree': 'Concedi account gratuito',
  'admin.users.blockUser': 'Blocca utente',
  'admin.users.cancellationPlaceholder': 'Perché l\'abbonamento viene cancellato?',
  'admin.users.selectPlan': 'Seleziona piano',
  'admin.users.subChanged': 'Abbonamento di {{name}} cambiato in {{plan}}',
  'admin.users.noReasonGiven': 'Nessuna motivazione fornita',
  'admin.users.subCancelled': 'Abbonamento di {{name}} cancellato (valido fino al {{date}})',
  'admin.users.paused': 'In pausa',
  'admin.users.subPaused': 'L\'abbonamento di {{name}} è stato messo in pausa',
  'admin.users.subReactivated': 'L\'abbonamento di {{name}} è stato riattivato',
  'admin.users.freeAccount': 'Account Gratuito',
  'admin.users.blocked': 'Bloccato',
  'admin.users.cancelledExpiring': 'Cancellato (in scadenza)',
  'admin.users.cancelledOn': 'Cancellato:',
  'admin.users.endsOn': 'Termina:',
  'admin.users.daysRemaining': 'giorni rimanenti',
  'admin.users.expired': '(Scaduto)',
  'admin.users.total': 'Totale:',
  'admin.users.usersLabel': 'utenti',
  'admin.users.free': 'gratuiti',
  'admin.users.block': 'Blocca',
  'admin.users.unblock': 'Sblocca',
  'admin.users.unblockUser': 'Sblocca utente',
  'admin.users.selectAction': 'Seleziona azione',
  'admin.users.cancelSub': 'Cancella abbonamento',
  'admin.users.cancelSubDesc': 'Cancellazione a fine mese',
  'admin.users.pauseSub': 'Metti in pausa abbonamento',
  'admin.users.pauseSubDesc': 'Pausa temporanea',
  'admin.users.changePlan': 'Cambia piano',
  'admin.users.changePlanDesc': 'Passa a un altro piano',
  'admin.users.reactivateSub': 'Riattiva abbonamento',
  'admin.users.reactivateDesc': 'Annulla cancellazione',
  'admin.users.alreadyCancelled': 'Abbonamento già cancellato',
  'admin.users.planLabel': 'Piano',
  'admin.users.cancellationReasonOpt': 'Motivo della cancellazione (opzionale)',
  'admin.users.cancelInfo1': 'L\'abbonamento terminerà il',
  'admin.users.cancelInfo2': '(fine mese). Fino ad allora l\'utente ha accesso completo. Nessun rimborso.',
  'admin.users.newPlan': 'Nuovo piano',
  'admin.users.warning': 'Attenzione',
  'admin.users.blockDesc': 'L\'utente verrà immediatamente disconnesso e non potrà più accedere. Tutte le sessioni attive verranno terminate.',
  'admin.users.confirmUnblock': 'Conferma sblocco',
  'admin.users.unblockDesc': 'L\'utente può accedere di nuovo e utilizzare tutte le funzionalità.',
  'admin.users.afterBlock': 'Dopo il blocco:',
  'admin.users.afterUnblock': 'Dopo lo sblocco:',
  'admin.users.noAccountAccess': 'Nessun accesso all\'account',
  'admin.users.noNewAnalyses': 'Nessuna nuova analisi possibile',
  'admin.users.creditsStored': 'Crediti e cronologia rimangono memorizzati',
  'admin.users.accessRestored': 'Accesso all\'account ripristinato',
  'admin.users.allFeaturesAvail': 'Tutte le funzionalità di nuovo disponibili',
  'admin.users.creditsPreserved': 'Crediti e cronologia preservati',
  'admin.users.downgrade': 'Declassa Piano',
  'admin.users.grantFreeBtn': 'Concedi gratuito',
  'admin.users.durationMonths': 'Durata (mesi)',
  'admin.users.months': 'mese(i)',
  'admin.users.freePlan': 'gratuito',
  'admin.users.freeSummary': 'riceve',
  'admin.users.withCredits': 'con',
  'admin.users.credits': 'Crediti',
  'admin.users.subInfo': 'Informazioni Abbonamento',
  'admin.users.currentPlan': 'Piano Attuale',
  'admin.users.joined': 'Iscritto il',
  'admin.users.totalSpent': 'Totale Speso',
  'admin.users.paymentMethod': 'Metodo di Pagamento',
  'admin.users.validThrough': 'Valida fino al',
  'admin.users.billingAddress': 'Indirizzo di Fatturazione',
  'admin.users.transactionHistory': 'Cronologia Transazioni',
  'admin.users.cancellationDate': 'Data di cancellazione',
  'admin.users.validUntil': 'Valido fino al (fine mese)',
  'admin.users.cancellationReason': 'Motivo della cancellazione',
  'admin.users.noReason': 'Nessuna motivazione fornita',
  'admin.users.timeRemaining': 'Tempo rimanente',
  'admin.users.daysUntilDeactivation': 'giorni alla disattivazione',
  'admin.table.user': 'Utente',
  'admin.table.plan': 'Piano',
  'admin.table.subStatus': 'Stato Abbonamento',
  'admin.table.cancellation': 'Cancellazione',
  'admin.table.payment': 'Metodo di Pagamento',
  'admin.table.spending': 'Spesa',
  'admin.table.actions': 'Azioni',
  'admin.actions.viewDetails': 'Visualizza dettagli',
  'admin.actions.manageSubscription': 'Gestisci abbonamento',
  'admin.actions.grantFree': 'Concedi accesso gratuito',
  'admin.actions.block': 'Blocca utente',
  'admin.actions.unblock': 'Sblocca utente',
  'admin.actions.cancel': 'Annulla',
  'admin.actions.save': 'Salva',
  'admin.actions.delete': 'Elimina',
  'admin.actions.confirm': 'Conferma',
  'admin.actions.done': 'Fatto',
  'admin.actions.edit': 'Modifica',
  'admin.actions.close': 'Chiudi',
  'admin.table.status': 'Stato',
  'admin.filter.all': 'Tutti',
  'admin.subscription.active': 'Attivo',
  'admin.subscription.cancelled': 'Cancellato',
  'admin.subscription.paused': 'In pausa',
  'admin.subscription.unknown': 'Sconosciuto',
  'admin.status.active': 'Attivo',
  'admin.status.inactive': 'Inattivo',
  'admin.status.pending': 'In attesa',
  'admin.status.approved': 'Approvato',
  'admin.status.rejected': 'Respinto',
  'admin.coupons.title': 'Gestione Coupon',
  'admin.coupons.subtitle': 'Crea e gestisci codici promozionali',
  'admin.coupons.newCoupon': 'Nuovo Coupon',
  'admin.coupons.registrationCoupons': 'Coupon di Registrazione',
  'admin.coupons.trialCoupons': 'Coupon di Accesso Prova',
  'admin.coupons.type': 'Tipo',
  'admin.coupons.plan': 'Piano',
  'admin.coupons.value': 'Valore',
  'admin.coupons.usage': 'Utilizzo',
  'admin.coupons.validUntil': 'Valido fino al',
  'admin.coupons.created': 'Creato',
  'admin.coupons.actions': 'Azioni',
  'admin.coupons.copyCode': 'Copia codice',
  'admin.coupons.allPlans': 'Tutti i Piani',
  'admin.coupons.discount': 'Sconto',
  'admin.coupons.days': 'giorni',
  'admin.coupons.months': 'mesi',
  'admin.coupons.free': 'gratuito',
  'admin.coupons.unlimited': 'Illimitato',
  'admin.coupons.createRegistration': 'Crea Coupon di Registrazione',
  'admin.coupons.createTrial': 'Crea Coupon di Accesso Prova',
  'admin.coupons.couponCode': 'Codice Coupon',
  'admin.coupons.codePlaceholder': 'es. NF-7X3K9M',
  'admin.coupons.generateCode': 'Genera nuovo codice',
  'admin.coupons.alertFillRequired': 'Compila tutti i campi obbligatori',
  'admin.coupons.alertSelectExpiry': 'Seleziona una data di scadenza o attiva "Validità illimitata"',
  'admin.coupons.alertCreateError': 'Errore durante la creazione del coupon',
  'admin.coupons.confirmDelete': 'Sei sicuro di voler eliminare questo coupon?',
  'admin.coupons.discountPercent': 'Sconto (%)',
  'admin.coupons.bonusCredits': 'Crediti Bonus',
  'admin.coupons.freeDuration': 'Durata Gratuita',
  'admin.coupons.maxUses': 'Utilizzi Massimi',
  'admin.coupons.expiryDate': 'Data di Scadenza',
  'admin.coupons.unlimitedValidity': 'Validità illimitata',
  'admin.coupons.unlimitedUses': 'Utilizzi illimitati',
  'admin.coupons.trialCredits': 'Crediti di Prova',
  'admin.coupons.trialDuration': 'Durata della Prova',
  'admin.coupons.typePlaceholder': 'es. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Durata',
  'admin.stats.totalUsers': 'Utenti Totali',
  'admin.stats.monthlyRevenue': 'Entrate Mensili',
  'admin.stats.activeSubscriptions': 'Abbonamenti Attivi',
  'admin.stats.average': 'Media',
  'admin.stats.revenuePerUser': 'Entrate per Utente',
  'admin.stats.grossRevenue': 'Entrate Lorde',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Entrate Nette',
  'admin.stats.churnRate': 'Tasso di Abbandono',
  'admin.stats.planDistribution': 'Distribuzione Piani',
  'admin.stats.users': 'utenti',
  'admin.stats.revenueByPlan': 'Entrate per Piano',
  'admin.stats.recentActivity': 'Attività Recenti',
  'admin.stats.activity1': 'Thomas Weber è passato a Builder',
  'admin.stats.activity2': 'Nuovo utente registrato',
  'admin.stats.activity3': 'Anna Schmidt è passata a Pro',
  'admin.stats.hoursAgo2': '2 ore fa',
  'admin.stats.hoursAgo5': '5 ore fa',
  'admin.stats.dayAgo1': '1 giorno fa',
  'admin.stats.couponStats': 'Statistiche Coupon',
  'admin.stats.totalRedemptions': 'Totale Riscatti',
  'admin.stats.activeCoupons': 'Coupon Attivi',
  'admin.stats.registrationRedemptions': 'Riscatti Registrazione',
  'admin.stats.trialRedemptions': 'Riscatti Prova',
  'admin.stats.couponDistribution': 'Distribuzione Coupon',
  'admin.stats.registrationCoupons': 'Coupon Registrazione',
  'admin.stats.trialCoupons': 'Coupon Prova',
  'admin.stats.expiredInactive': 'Scaduti/Inattivi',
  'admin.stats.topCoupons': 'Coupon Più Utilizzati',
  'admin.stats.redemptions': 'riscatti',
  'admin.stats.noCouponsRedeemed': 'Nessun coupon ancora riscattato',
  'admin.downgrade.pending': 'in attesa',
  'admin.downgrade.refunds': 'Rimborsi',
  'admin.downgrade.sectionRequests': 'Richieste',
  'admin.downgrade.sectionStats': 'Statistiche',
  'admin.downgrade.sectionRules': 'Regole',
  'admin.downgrade.pendingRequests': 'Richieste in Attesa',
  'admin.downgrade.approvedRequests': 'Richieste Approvate',
  'admin.downgrade.rejectedRequests': 'Richieste Respinte',
  'admin.downgrade.activeRules': 'Regole Attive',
  'admin.downgrade.autoRules': 'Regole di Declassamento Automatico',
  'admin.downgrade.autoRulesDesc': 'Crea regole che attivano automaticamente declassamenti in base al comportamento di utilizzo',
  'admin.downgrade.newRule': 'Nuova Regola',
  'admin.downgrade.totalRules': 'Regole Totali',
  'admin.downgrade.triggeredActions': 'Azioni Attivate',
  'admin.downgrade.conditionsAnd': 'Condizioni (collegate con AND)',
  'admin.downgrade.action': 'Azione',
  'admin.downgrade.successTitle': 'Declassamento riuscito!',
  'admin.downgrade.successDesc': 'L\'utente è stato declassato con successo e il rimborso è stato elaborato.',
  'admin.downgrade.closing': 'Chiusura...',
  'admin.downgrade.title': 'Declassa Utente',
  'admin.downgrade.currentPlan': 'Piano Attuale',
  'admin.downgrade.spending': 'Spesa',
  'admin.downgrade.availablePlans': 'Piani Disponibili per il Declassamento',
  'admin.downgrade.perMonth': 'al mese',
  'admin.downgrade.refundCalc': 'Calcolo Rimborso',
  'admin.downgrade.currentPlanLabel': 'Piano Attuale',
  'admin.downgrade.newPlan': 'Nuovo Piano',
  'admin.downgrade.remainingDays': 'Giorni Rimanenti',
  'admin.downgrade.daysOf': '15 di 30 giorni',
  'admin.downgrade.proRataRefund': 'Rimborso Proporzionale',
  'admin.downgrade.importantNote': 'Nota Importante',
  'admin.downgrade.warningDesc': 'Il declassamento verrà eseguito immediatamente. L\'utente perderà l\'accesso alle funzionalità premium e i crediti in eccesso verranno rimossi.',
  'admin.downgrade.processing': 'Elaborazione...',
  'admin.downgrade.execute': 'Esegui Declassamento',
  'admin.downgrade.notification': 'Notifica',
  'admin.downgrade.noNotification': 'Nessuna Notifica',
  'admin.downgrade.daysPeriod': 'giorni di preavviso',
  'admin.downgrade.created': 'Creato:',
  'admin.downgrade.triggered': 'attivata',
  'admin.downgrade.noRules': 'Nessuna regola ancora creata',
  'admin.downgrade.createFirstRule': 'Crea la prima regola',
  'admin.downgrade.editRule': 'Modifica Regola',
  'admin.downgrade.createRule': 'Crea Nuova Regola',
  'admin.downgrade.ruleName': 'Nome regola',
  'admin.downgrade.description': 'Descrizione',
  'admin.downgrade.allConditions': 'Condizioni (tutte devono essere soddisfatte)',
  'admin.downgrade.addCondition': 'Aggiungi condizione',
  'admin.downgrade.type': 'Tipo',
  'admin.downgrade.value': 'Valore',
  'admin.downgrade.fromPlan': 'Dal piano',
  'admin.downgrade.toPlan': 'Al piano',
  'admin.condition.inactivity': 'Inattività',
  'admin.condition.creditUsage': 'Utilizzo Crediti',
  'admin.condition.loginFrequency': 'Frequenza di Accesso',
  'admin.condition.featureUsage': 'Utilizzo Funzionalità',
  'admin.condition.supportTickets': 'Ticket di Supporto',
  'admin.operator.lessThan': 'minore di',
  'admin.operator.greaterThan': 'maggiore di',
  'admin.operator.equals': 'esattamente',
  'admin.operator.between': 'tra',
  'admin.unit.days': 'giorni',
  'admin.unit.perMonth': 'al mese',
  'admin.unit.count': 'conteggio',
  'admin.transactions.all': 'Tutte le Transazioni',
  'admin.transactions.allCards': 'Tutte le Carte',
  'admin.transactions.notFound': 'Nessuna transazione trovata',
  'admin.transactions.totalLabel': 'Totale',
  'admin.transactions.transactions': 'transazioni',
  'admin.tips.title': 'Suggerimento del Giorno',
  'admin.tips.subtitle': 'Crea e gestisci suggerimenti mostrati a tutti gli utenti',
  'admin.tips.active': 'Attivo',
  'admin.tips.currentlyShown': 'Questo suggerimento è attualmente mostrato a tutti gli utenti',
  'admin.tips.createNew': 'Crea Nuovo Suggerimento',
  'admin.tips.generating': 'Generazione in corso...',
  'admin.tips.generateAI': 'Genera Suggerimento AI',
  'admin.tips.titleLabel': 'Titolo',
  'admin.tips.titlePlaceholder': 'es. Suggerimento del Giorno',
  'admin.tips.category': 'Categoria',
  'admin.tips.categoryTip': 'Suggerimento',
  'admin.tips.categoryFeature': 'Nuova Funzionalità',
  'admin.tips.categoryProductivity': 'Produttività',
  'admin.tips.categoryUpdate': 'Aggiornamento',
  'admin.tips.content': 'Contenuto',
  'admin.tips.contentPlaceholder': 'Scrivi qui il tuo suggerimento per gli utenti...',
  'admin.tips.addTip': 'Aggiungi Suggerimento',
  'admin.tips.allTips': 'Tutti i Suggerimenti',
  'admin.tips.noTips': 'Nessun suggerimento ancora creato',
  'admin.tips.noTipsHint': 'Clicca "Genera Suggerimento AI" per iniziare',
  'admin.noData': 'Nessun dato disponibile',
  'admin.range.7d': '7 giorni',
  'admin.range.30d': '30 giorni',
  'admin.range.90d': '90 giorni',
  'admin.range.1y': '1 anno',
  'admin.actions.saveSettings': 'Salva impostazioni',
  'admin.actions.create': 'Crea',
  'admin.downgrade.sectionReports': 'Report',
  'admin.downgrade.settings': 'Impostazioni Declassamento',
  'admin.downgrade.autoApprove': 'Approvazione Automatica',
  'admin.downgrade.autoApproveDesc': 'Approva automaticamente le richieste di declassamento',
  'admin.downgrade.refundPolicy': 'Politica di Rimborso',
  'admin.downgrade.prorata': 'Rimborso proporzionale',
  'admin.downgrade.prorataDesc': 'Rimborso proporzionale basato sui giorni rimanenti',
  'admin.downgrade.fullRefund': 'Rimborso completo',
  'admin.downgrade.fullRefundDesc': 'Rimborso completo della differenza di prezzo',
  'admin.downgrade.noRefund': 'Nessun rimborso',
  'admin.downgrade.noRefundDesc': 'Declassamento senza rimborso',
  'admin.downgrade.daysRemaining15': '(con 15 giorni rimanenti)',
  'admin.downgrade.requestsTitle': 'Richieste di Declassamento',
  'admin.downgrade.approvalRate': 'Tasso di approvazione',
  'admin.downgrade.mostCommonTransition': 'Transizione più comune',
  'admin.downgrade.mostCommonReason': 'Motivo più comune',
  'admin.downgrade.avgProcessingTime': 'Tempo medio di elaborazione',
  'admin.downgrade.avgTimeDesc': 'Tempo medio per la decisione',
  'admin.downgrade.totalRefunds': 'Rimborsi Totali',
  'admin.downgrade.pendingRefunds': 'Rimborsi in Attesa',
  'admin.downgrade.summary': 'Riepilogo',
  'admin.downgrade.total': 'Totale',
  'admin.downgrade.csvDesc': 'Per Excel, Fogli Google',
  'admin.downgrade.downloadCSV': 'Scarica come CSV',
  'admin.downgrade.jsonDesc': 'Per sviluppatori, API',
  'admin.downgrade.downloadJSON': 'Scarica come JSON',
  'admin.downgrade.exportInfo': 'L\'esportazione contiene',
  'admin.downgrade.entries': 'voci del periodo selezionato',
  'admin.downgrade.topReasons': 'Motivi di declassamento più comuni',
  'admin.downgrade.refundHistory': 'Cronologia Rimborsi',
  'admin.downgrade.noRefunds': 'Nessun rimborso ancora',
  'admin.downgrade.statistics': 'Statistiche Declassamento',
  'admin.downgrade.requests': 'Richieste',
  'admin.downgrade.monthlyTrend': 'Andamento Mensile',
  'admin.downgrade.planTransitions': 'Transizioni di Piano',
  'admin.downgrade.trend': 'Andamento (vs. mese prec.)',
  'admin.downgrade.trendDesc': 'Meno declassamenti = migliore',
  'admin.coupons.allPlansUniversal': 'Tutti i Piani (Universale)',
  'admin.coupons.onlyStarter': 'Solo Starter',
  'admin.coupons.onlyPro': 'Solo Pro',
  'admin.coupons.onlyBuilder': 'Solo Builder',
  'admin.coupons.allPlansHint': 'Scegli "Tutti i Piani" per un coupon universale',
  'admin.coupons.discountOptional': 'Sconto % (opzionale)',
  'admin.coupons.discountPlaceholder': 'es. 50 per 50% di sconto',
  'admin.coupons.bonusCreditsOptional': 'Crediti Bonus (opzionale)',
  'admin.coupons.bonusCreditsPlaceholder': 'es. 500',
  'admin.coupons.freeDurationOptional': 'Durata Gratuita (opzionale)',
  'admin.coupons.durationPlaceholder': 'es. 30',
  'admin.coupons.freeDurationHint': 'es. 30 giorni di utilizzo gratuito',
  'admin.coupons.noLimit': 'Nessuna limitazione di utilizzo',
  'admin.coupons.noExpiry': 'Nessuna data di scadenza',
  'admin.coupons.creditsPlaceholder': 'es. 100',
  'admin.coupons.creditsHint': 'Numero di crediti per l\'accesso di prova',
  'admin.coupons.trialDurationHint': 'Per quanto tempo è valido l\'accesso di prova',
  'admin.coupons.autoCalculated': 'Calcolato automaticamente dalla durata della prova',
  'admin.websiteEditor.title': 'Editor Sito Web',
  'admin.websiteEditor.subtitle': 'Modifica tutte le sezioni della homepage',
  'admin.websiteEditor.openPreview': 'Apri Anteprima',
  'admin.websiteEditor.group.structure': 'Struttura della Pagina',
  'admin.websiteEditor.group.design': 'Design e Layout',
  'admin.websiteEditor.group.settings': 'Impostazioni',
  'admin.websiteEditor.tab.navbar': 'Navigazione',
  'admin.websiteEditor.tab.howitworks': 'Come Funziona',
  'admin.websiteEditor.tab.about': 'Chi Siamo',
  'admin.websiteEditor.tab.pricing': 'Prezzi',
  'admin.websiteEditor.tab.sections': 'Sezioni',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Parla con Noi',
  'admin.websiteEditor.tab.invoice': 'Fatture',
  'admin.websiteEditor.tab.legal': 'Legale',
  'admin.websiteEditor.tab.seo': 'SEO Base',
  'admin.websiteEditor.tab.advancedseo': 'SEO Avanzato',
  'admin.websiteEditor.tab.versions': 'Versioni',
  'admin.hero.title': 'Modifica Sezione Hero',
  'admin.hero.subtitle': 'Testi, pulsanti e statistiche della homepage',
  'admin.hero.reset': 'Reimposta',
  'admin.hero.save': 'Salva',
  'admin.hero.savedMsg': 'Dati Hero salvati!',
  'admin.hero.badge': 'Testo del Badge',
  'admin.hero.headings': 'Intestazioni',
  'admin.hero.line1White': 'Riga 1 (bianca)',
  'admin.hero.line2Gold': 'Riga 2 (dorata)',
  'admin.hero.subtitleSection': 'Sottotitolo',
  'admin.hero.line1': 'Riga 1',
  'admin.hero.line2': 'Riga 2',
  'admin.hero.buttons': 'Pulsanti',
  'admin.hero.primaryBtn': 'Pulsante Primario (dorato)',
  'admin.hero.secondaryBtn': 'Pulsante Secondario (bordo)',
  'admin.hero.stats': 'Statistiche',
  'admin.hero.statN': 'Statistica {{n}}',
  'admin.hero.value': 'Valore',
  'admin.hero.label': 'Etichetta',
  'admin.hero.previewNote': 'Le modifiche saranno visibili sulla homepage dopo il salvataggio. Ricarica la pagina per vedere l\'anteprima.',

  // Cronologia Idee
  'history.title': 'Cronologia Idee',
  'history.countLabel': '{{count}} analisi',
  'history.recentLabel': 'Le tue analisi recenti',
  'history.exportAll': 'Esporta tutto',
  'history.metrics.marketSize': 'Dimensione Mercato',
  'history.metrics.competition': 'Concorrenza',
  'history.metrics.startingCapital': 'Capitale Iniziale',
  'history.metrics.timeToMarket': 'Tempo di Lancio',
  'history.metrics.profitPotential': 'Potenziale di Profitto',
  'history.metrics.scalability': 'Scalabilità',
  'history.summary.title': 'Riepilogo',
  'history.download': 'Scarica',
  'history.downloadJSON': 'Salva come JSON',
  'history.downloadTXT': 'Salva come TXT',
  'history.downloadPDF': 'Salva come PDF',
  'history.fullAnalysis': 'Analisi Completa',
  'history.searchPlaceholder': 'Cerca per titolo o tag...',
  'history.filterAll': 'Tutte le valutazioni',
  'history.loading': 'Caricamento analisi...',
  'history.noResults': 'Nessun risultato trovato',
  'history.empty': 'Nessuna analisi ancora',
  'history.emptyHint': 'Inizia un\'analisi nell\'Assistente AI',
  'history.delete': 'Elimina',
  'history.cancel': 'Annulla',
  'history.deleteModalTitle': 'Eliminare l\'analisi?',
  'history.deleteModalDesc': '"{{title}}" verrà eliminata permanentemente.',
  'history.errorLoading': 'Errore durante il caricamento delle analisi',
  'history.deleteSuccess': 'Analisi eliminata con successo',
  'history.deleteError': 'Errore durante l\'eliminazione dell\'analisi',
  'history.jsonExported': 'JSON esportato',
  'history.txtExported': 'TXT esportato',
  'history.allExported': '{{count}} idee esportate',
  'history.analysisHeader': 'ANALISI IDEA',
  'history.titleLabel': 'Titolo',
  'history.ratingLabel': 'Valutazione',
  'history.dateLabel': 'Data',
  'history.creditsLabel': 'Crediti',
  'history.analysisSection': 'Analisi',

  // Panoramica
  'overview.title': 'Panoramica',
  'overview.last24h': 'Ultime 24 ore',
  'overview.analysesToday': 'Analisi oggi',
  'overview.totalAnalyses': 'Analisi totali',
  'overview.successRate': 'Tasso di successo',
  'overview.topRatings': 'Migliori valutazioni',
  'overview.recentActivity': 'Attività recenti',
  'overview.viewAll': 'Vedi tutto',
  'overview.quickAccess': 'Accesso rapido',
  'overview.quick.newAnalysis': 'Inizia nuova analisi',
  'overview.quick.newAnalysisDesc': 'Avvia una nuova analisi di nicchia con AI',
  'overview.quick.myAnalyses': 'Le mie analisi',
  'overview.quick.myAnalysesDesc': 'Visualizza tutte le analisi precedenti',
  'overview.quick.buyCredits': 'Acquista crediti',
  'overview.quick.buyCreditsDesc': 'Più crediti per più analisi',
  'overview.quick.settings': 'Impostazioni',
  'overview.quick.settingsDesc': 'Personalizza profilo e preferenze',
  'overview.unlimitedCredits': 'Crediti illimitati disponibili',
  'overview.creditsAvailable': 'crediti disponibili',
  'overview.upgradePlan': 'Aggiorna piano',
  'overview.buyCredits': 'Acquista crediti',
  'overview.creditUsage': 'Utilizzo crediti questo mese',
  'overview.available': 'disponibili',

  // --- Nuove Chiavi Admin ---
  'admin.transactions.upgrades': 'Aggiornamenti',
  'admin.transactions.downgrades': 'Declassamenti',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} ora ha {{months}} mese(i) di piano {{plan}} gratuito',
  'admin.users.blockSuccess': '{{name}} è stato bloccato',
  'admin.users.unblockSuccess': '{{name}} è stato sbloccato',
  'admin.users.removeFreeSuccess': 'Lo stato gratuito di {{name}} è stato rimosso',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratuito',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Scopri Nuova Funzionalità',
  'admin.tips.productivityBoost': 'Aumento di Produttività',
  'admin.tips.importantUpdate': 'Aggiornamento Importante',
  'admin.tips.tipOfDay': 'Suggerimento del Giorno',

  'admin.actions.activate': 'Attiva',
  'admin.actions.deactivate': 'Disattiva',
  'admin.websiteEditor.tab.features': 'Funzionalità',
  'admin.websiteEditor.tab.testimonials': 'Testimonianze',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Footer',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Codice Personalizzato',
  'admin.websiteEditor.tab.socials': 'Social Media',
  'admin.websiteEditor.tab.importexport': 'Importa/Esporta',

  // --- Editor Impostazioni AI ---
  'admin.ai.title': 'Impostazioni Assistente AI',
  'admin.ai.subtitle': 'Configura comportamento, stile e profondità di analisi',
  'admin.ai.smartWeightingActive': 'Pesatura Intelligente Attiva',
  'admin.ai.smartWeightingDesc': 'L\'AI combina automaticamente tutte le prospettive con una pesatura intelligente. Con più preset, il primo ha la pesatura maggiore (preset primario). Puoi anche regolare la pesatura manualmente.',
  'admin.ai.modelTitle': 'Modello AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'Scegli il motore AI per tutte le analisi degli utenti',
  'admin.ai.activeModel': 'Modello attivo:',
  'admin.ai.activeModelDesc': 'Tutti gli utenti ricevono risposte da questo modello.',
  'admin.ai.recommendations': 'Raccomandazioni per Risultati Ottimali',
  'admin.ai.new': 'NUOVO',
  'admin.ai.recommendationsDesc': 'Combinazioni di preset collaudate per la migliore qualità di analisi',
  'admin.ai.recommendationsInfo': 'Queste combinazioni sono state testate e offrono i migliori risultati. Clicca su una raccomandazione per applicarla direttamente.',
  'admin.ai.active': 'ATTIVO',
  'admin.ai.apply': 'Applica',
  'admin.ai.avoid': 'Evita',
  'admin.ai.excellentQuality': 'Qualità Eccellente',
  'admin.ai.goodQuality': 'Buona Qualità',
  'admin.ai.poorQuality': 'Qualità Diluita - Non Raccomandato',
  'admin.ai.proTips': 'Pro Tips',
  'admin.ai.tip1Title': '2 preset sono ottimali:',
  'admin.ai.tip1Desc': 'Prospettiva chiara senza diluizione',
  'admin.ai.tip2Title': 'Il preset primario è importante:',
  'admin.ai.tip2Desc': 'Il primo preset ha la maggiore influenza',
  'admin.ai.tip3Title': 'Evita gli opposti:',
  'admin.ai.tip3Desc': '"ESTREMO" + "Creativo" = contraddittorio',
  'admin.ai.tip4Title': 'Massimo 3 preset:',
  'admin.ai.tip4Desc': 'Con 4+ preset il risultato diventa troppo generico',
  'admin.ai.warningManyPresets': 'Attenzione: Molti Preset',
  'admin.ai.warningManyPresetsDesc': 'Hai {{count}} preset selezionati. Questo può diluire il risultato.',
  'admin.ai.warningRecommend': 'Raccomandato: Massimo 2-3 preset',
  'admin.ai.forOptimalResults': 'per risultati ottimali.',
  'admin.ai.presets': 'Preset',
  'admin.ai.multiSelect': '(selezione multipla possibile)',
  'admin.ai.presetsDesc': 'Scegli uno o più preset. Il primo preset è il preset primario con la pesatura più alta.',
  'admin.ai.primaryPreset': 'Preset Primario',
  'admin.ai.weightControl': 'Controllo Pesi',
  'admin.ai.weightControlDesc': 'Regola quanto fortemente ogni preset influenza l\'analisi',
  'admin.ai.manual': 'Manuale',
  'admin.ai.automatic': 'Automatico',
  'admin.ai.autoWeightingActive': 'Pesatura automatica attiva:',
  'admin.ai.autoWeightingDesc': 'La pesatura viene ottimizzata automaticamente in base al numero di preset.',
  'admin.ai.primary': 'PRIMARIO',
  'admin.ai.totalWeight': 'Totale',
  'admin.ai.shouldBe100': 'dovrebbe essere 100%',
  'admin.ai.normalize': 'Normalizza',
  'admin.ai.combinedSettings': 'Impostazioni Combinate',
  'admin.ai.presetsCount': 'preset',
  'admin.ai.strictness': 'Severità',
  'admin.ai.realism': 'Realismo',
  'admin.ai.creativity': 'Creatività',
  'admin.ai.detailLevel': 'Livello di Dettaglio',
  'admin.ai.customInstructions': 'Istruzioni Personalizzate',
  'admin.ai.customInstructionsDesc': 'Istruzioni aggiuntive che vengono combinate con i preset',
  'admin.ai.customInstructionsPlaceholder': 'es. "Concentrati sul mercato DACH", "Usa sempre numeri concreti", "Confronta con i concorrenti esistenti", "Rispondi sempre con esempi"...',
  'admin.ai.customInstructionsHint': 'Queste istruzioni vengono automaticamente combinate con i preset selezionati.',
  'admin.ai.manualFinetuning': 'Ottimizzazione Manuale',
  'admin.ai.manualFinetuningHint': '(opzionale, sovrascrive i valori dei preset)',
  'admin.ai.manualFinetuningDesc': 'Regola manualmente i valori combinati se vuoi ottimizzare qualcosa.',
  'admin.ai.tone': 'Tono',
  'admin.ai.mild': 'Mite',
  'admin.ai.strict': 'Severo',
  'admin.ai.creative': 'Creativo',
  'admin.ai.realistic': 'Realistico',
  'admin.ai.conservative': 'Conservativo',
  'admin.ai.compact': 'Compatto',
  'admin.ai.detailed': 'Dettagliato',
  'admin.ai.responseLength': 'Lunghezza Risposta',
  'admin.ai.short': 'Breve e Conciso',
  'admin.ai.medium': 'Media',
  'admin.ai.long': 'Dettagliata',
  'admin.ai.focusAreas': 'Aree di Focus dell\'Analisi',
  'admin.ai.autoRating': 'Valutazione Automatica',
  'admin.ai.autoRatingDesc': 'Ogni analisi riceve automaticamente una valutazione (Buono/Medio/Scarso)',
  'admin.ai.showSources': 'Mostra Fonti',
  'admin.ai.showSourcesDesc': 'Riferimenti a fonti di dati e dati di mercato nelle risposte',
  'admin.ai.hidePreview': 'Nascondi Anteprima',
  'admin.ai.showPreview': 'Mostra Anteprima',
  'admin.ai.aiBehavior': 'Comportamento AI',
  'admin.ai.length': 'Lunghezza',
  'admin.ai.liveExample': 'Esempio Live',
  'admin.ai.testSettings': 'Testa le tue impostazioni',
  'admin.ai.selectExampleQuestion': 'Seleziona domanda di esempio:',
  'admin.ai.userAsks': 'L\'utente chiede:',
  'admin.ai.generating': 'L\'AI sta generando la risposta...',
  'admin.ai.generateExample': 'Genera Risposta di Esempio',
  'admin.ai.aiResponds': 'L\'Assistente AI risponde:',
  'admin.ai.generateHint': 'Clicca "Genera Risposta di Esempio" per vedere come l\'AI risponde con le tue impostazioni.',
  'admin.ai.reset': 'Reimposta',
  'admin.ai.saved': 'Salvato!',
  'admin.ai.saveSettings': 'Salva Impostazioni',

  // --- Intestazioni tabella ---
  'admin.coupons.code': 'Codice',
  'admin.coupons.credits': 'Crediti',

  // --- Descrizioni Modelli AI ---
  'admin.ai.model.standardDesc': 'Analisi bilanciata con alta qualità. La scelta migliore per la maggior parte delle valutazioni di nicchia e validazioni di idee.',
  'admin.ai.model.preciseAnalyses': 'Analisi Precise',
  'admin.ai.model.bestBalance': 'Miglior Bilanciamento',
  'admin.ai.model.recommended': 'Raccomandato',
  'admin.ai.model.fastDesc': 'Risposte rapidissime per controlli rapidi di nicchia, brainstorming e valutazioni iniziali. Ideale quando la velocità conta.',
  'admin.ai.model.fast': 'VELOCE',
  'admin.ai.model.fastestResponses': 'Risposte Più Veloci',
  'admin.ai.model.thinkingDesc': 'Analisi approfondita con ragionamento logico avanzato. Per analisi di mercato complesse, valutazioni critiche e pianificazione strategica.',
  'admin.ai.model.deepestAnalysis': 'Analisi Più Profonda',
  'admin.ai.model.logicalThinking': 'Ragionamento Logico',
  'admin.ai.model.strategy': 'Strategia',

  // --- Nomi e Descrizioni Preset AI ---
  'admin.ai.preset.strict.name': 'Analisi Severa',
  'admin.ai.preset.strict.desc': 'Critica, basata sui fatti, niente zucchero. Rivela spietatamente i punti deboli.',
  'admin.ai.preset.extreme.name': 'Analisi ESTREMA',
  'admin.ai.preset.extreme.desc': 'Massima severità, critica spietata, focus sul caso peggiore. Solo per controlli di realtà duri.',
  'admin.ai.preset.professional.name': 'Professionale',
  'admin.ai.preset.professional.desc': 'Obiettivo, strutturato, bilanciato. Come un consulente aziendale esperto.',
  'admin.ai.preset.realistic.name': 'Realistico',
  'admin.ai.preset.realistic.desc': 'Onesto e pratico. Focus sull\'implementazione fattibile e sui dati di mercato reali.',
  'admin.ai.preset.creative.name': 'Creativo e Motivante',
  'admin.ai.preset.creative.desc': 'Ispiratore, ricco di idee, positivo. Trova opportunità e percorsi non convenzionali.',
  'admin.ai.preset.balanced.name': 'Bilanciato',
  'admin.ai.preset.balanced.desc': 'Buon mix di critica e motivazione. La modalità predefinita.',
  'admin.ai.preset.investor.name': 'Prospettiva dell\'Investitore',
  'admin.ai.preset.investor.desc': 'Come un Venture Capitalist. Focus su scalabilità, ROI e strategia di uscita.',
  'admin.ai.preset.startup-coach.name': 'Startup Coach',
  'admin.ai.preset.startup-coach.desc': 'Mentore pratico per fondatori. Focus su implementazione rapida e MVP.',
  'admin.ai.preset.market-researcher.name': 'Ricercatore di Mercato',
  'admin.ai.preset.market-researcher.desc': 'Guidato dai dati e analitico. Analisi approfondita del mercato e della concorrenza.',
  'admin.ai.preset.risk-analyst.name': 'Analista dei Rischi',
  'admin.ai.preset.risk-analyst.desc': 'Focus sui rischi e sugli scenari peggiori. Per una pianificazione realistica.',

  // --- Aree di Focus ---
  'admin.ai.focus.marktanalyse': 'Analisi di Mercato',
  'admin.ai.focus.wettbewerb': 'Concorrenza',
  'admin.ai.focus.monetarisierung': 'Monetizzazione',
  'admin.ai.focus.risiken': 'Rischi',
  'admin.ai.focus.finanzen': 'Finanza',
  'admin.ai.focus.skalierung': 'Scalabilità',
  'admin.ai.focus.innovation': 'Innovazione',
  'admin.ai.focus.trends': 'Tendenze',
  'admin.ai.focus.differenzierung': 'Differenziazione',
  'admin.ai.focus.umsetzung': 'Implementazione',
  'admin.ai.focus.zielgruppe': 'Pubblico Target',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Opzioni di Tono ---
  'admin.ai.tone.direkt': 'Diretto e Brusco',
  'admin.ai.tone.professionell': 'Professionale e Obiettivo',
  'admin.ai.tone.ehrlich': 'Onesto e Pratico',
  'admin.ai.tone.motivierend': 'Motivante e Positivo',
  'admin.ai.tone.freundlich': 'Amichevole e Di Supporto',
  'admin.ai.tone.akademisch': 'Accademico e Analitico',

  // --- Domande di Esempio ---
  'admin.ai.question.niche': 'Quale nicchia redditizia raccomandi?',
  'admin.ai.question.evaluate': 'Valuta la mia idea: Un\'app per proprietari di cani',
  'admin.ai.question.trends': 'Quali tendenze hanno attualmente potenziale?',
  'admin.ai.question.sharpen': 'Come posso affinare la mia nicchia?',

  'admin.ai.rec.bestCombination.title': '🏆 Miglior Combinazione (2 Preset)',
  'admin.ai.rec.bestCombination.desc': 'Critica ma costruttiva, con passi d\'azione concreti',
  'admin.ai.rec.bestCombination.useCase': 'Raccomandata per la maggior parte delle analisi',

  'admin.ai.rec.balancedThree.title': '⚖️ Bilanciato (3 Preset)',
  'admin.ai.rec.balancedThree.desc': 'Professionale, realistico e adatto agli investitori',
  'admin.ai.rec.balancedThree.useCase': 'Per analisi aziendali complete',

  'admin.ai.rec.creativeDriven.title': '💡 Creativo e Motivante (2 Preset)',
  'admin.ai.rec.creativeDriven.desc': 'Ispiratore con suggerimenti pratici di implementazione',
  'admin.ai.rec.creativeDriven.useCase': 'Per ideazione e brainstorming',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Utilizzo',
  'admin.usage.title': 'Utilizzo dell\'IA e Analisi dei Costi',
  'admin.usage.refresh': 'Aggiorna dati',
  'admin.usage.requests': 'Richieste',
  'admin.usage.users': 'Utenti',
  'admin.usage.totalTokens': 'Token Totali',
  'admin.usage.apiCosts': 'Costi API',
  'admin.usage.revenue': 'Entrate',
  'admin.usage.margin': 'Margine',
  'admin.usage.byModel': 'Per Modello',
  'admin.usage.allModels': 'Tutti i Modelli',
  'admin.usage.searchEmail': 'Cerca per indirizzo email...',
  'admin.usage.perPage': 'Per pagina:',
  'admin.usage.loading': 'Caricamento dati di utilizzo...',
  'admin.usage.noEntries': 'Nessuna voce trovata per i filtri attuali.',
  'admin.usage.time': 'Ora',
  'admin.usage.user': 'Utente',
  'admin.usage.model': 'Modello',
  'admin.usage.credits': 'Crediti',
  'admin.usage.tokens': 'Token',
  'admin.usage.duration': 'Durata',
  'admin.usage.details': 'Dettagli',
  'admin.usage.showing': 'Mostrando',
  'admin.usage.of': 'di',
  'admin.usage.entries': 'voci',
  'admin.usage.firstPage': 'Prima Pagina',
  'admin.usage.prevPage': 'Precedente',
  'admin.usage.page': 'Pagina',
  'admin.usage.nextPage': 'Successivo',
  'admin.usage.lastPage': 'Ultima Pagina',
  'admin.usage.requestDetails': 'Dettagli Richiesta',
  'admin.usage.close': 'Chiudi',
  'admin.usage.loadingDetails': 'Caricamento dettagli...',
  'admin.usage.inputTokens': 'Token di Input',
  'admin.usage.outputTokens': 'Token di Output',
  'admin.usage.providerCost': 'Costo del Fornitore',
  'admin.usage.providerBreakdown': 'Ripartizione Fornitore',
  'admin.usage.fullResponseData': 'Dati di Risposta Completi',
  'admin.usage.entryNotFound': 'Questa voce non è potuta essere caricata.',
  'admin.usage.today': 'Oggi',
  'admin.usage.last7d': 'Ultimi 7 giorni',
  'admin.usage.last30d': 'Ultimi 30 giorni',
  'admin.usage.allTime': 'Sempre',
  'admin.ai.fallbackModel': 'Modello di Riserva',
  'admin.ai.systemPrompts': 'Prompt di Sistema',
  'admin.ai.fallbackModelDesc': 'Utilizzato quando il modello principale fallisce o restituisce un output non valido',
  'admin.ai.systemPromptsDesc': 'Visualizzazione di sola lettura delle istruzioni ricevute da ogni modello',
  'admin.ai.provider': 'Fornitore',
  'admin.ai.modelId': 'ID Modello',
  'admin.ai.maxTokens': 'Token Max',
  'admin.ai.temperature': 'Temperatura',
  'admin.ai.thinkingBudget': 'Budget di Pensiero',
  'admin.ai.supportsThinking': 'Supporta il Pensiero',
  'admin.ai.displayName': 'Nome Visualizzato',
  'admin.ai.precise': 'Preciso',
  'admin.ai.creativeTemp': 'Creativo',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Apri menu',
  'header.home': 'Home',
  'header.notifications': 'Notifiche',
  'header.settings': 'Impostazioni',
  'header.profile': 'Profilo',
  'sidebar.collapse': 'Comprimi barra laterale',
  'sidebar.expand': 'Espandi barra laterale',
  'sidebar.close': 'Chiudi menu',
  'sidebar.plan': 'Piano',
  'sidebar.backToWebsite': 'Torna al sito',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Note legali',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, Emirati Arabi Uniti (EAU)',
  'legal.imprint.seatLabel': 'Sede legale',
  'legal.imprint.seatBody': 'Dubai, Emirati Arabi Uniti',
  'legal.imprint.contactLabel': 'Contatti',
  'legal.imprint.contactBody': 'I dati di contatto sono forniti a esclusiva discrezione di Scherbius Technology.',
  'legal.imprint.representationLabel': 'Rappresentanza legale',
  'legal.imprint.representationBody': 'Scherbius Technology è rappresentata dai suoi rappresentanti legali ai sensi del diritto degli Emirati Arabi Uniti.',
  'legal.imprint.contentLiabilityLabel': 'Responsabilità per i contenuti',
  'legal.imprint.contentLiabilityBody': 'I contenuti di questo sito sono stati realizzati con la massima cura possibile.\nScherbius Technology non si assume tuttavia alcuna responsabilità per l\'accuratezza, la completezza o l\'attualità dei contenuti.',
  'legal.imprint.linksLiabilityLabel': 'Responsabilità per link esterni',
  'legal.imprint.linksLiabilityBody': 'Questo sito può contenere link a siti esterni di terzi sui cui contenuti non si ha alcuna influenza.\nNon si assume alcuna responsabilità per tali contenuti esterni.',
  'legal.imprint.lawLabel': 'Diritto applicabile',
  'legal.imprint.lawBody': 'Si applica esclusivamente il diritto degli Emirati Arabi Uniti.\nIl foro competente è Dubai, EAU.',

  // Overview page (auto-added)
  'overview.greeting': 'Bentornato',
  'overview.greetingSub': 'Ecco cosa sta succedendo sulla tua scrivania dei verdetti.',
  'overview.heroCta': 'Nuovo verdetto',
  'overview.currentPlan': 'Piano attuale',
  'overview.creditsLabel': 'crediti',
  'overview.usedThisCycle': 'Usati questo ciclo',
  'overview.resetsOn': 'Si resetta il',
  'overview.unlimitedTitle': 'Illimitato',
  'overview.builderPerk': 'Hai accesso Builder completo — senza limiti.',
  'overview.runOne': 'Avvia un verdetto',
  'overview.lastVerdicts': 'I tuoi ultimi 5 verdetti',
  'overview.noActivity': 'Ancora nessun verdetto — avvia la tua prima analisi',
  'overview.tipTitle': 'Suggerimento',
  'overview.tipBody': 'Fai passare un\'idea da due lingue — se il verdetto si ammorbidisce, le tue assunzioni sono locali, non universali.',
  'onboard.skip': "Salta",
  'onboard.cta.next': "Avanti",
  'onboard.cta.start': "Inizia",
  'onboard.s1.title': "Benvenuto su IdeaVerdict",
  'onboard.s1.body': "Un verdetto AI sulla tua idea imprenditoriale — prima di costruirla.",
  'onboard.s2.title': "Verdetti brutalmente onesti",
  'onboard.s2.body': "Nessun hype, nessuna lusinga. Dati di mercato reali, concorrenti reali, rischi reali.",
  'onboard.s3.title': "Report Builder in PDF",
  'onboard.s3.body': "Genera report da 25 a 75 pagine con architettura completa, finanza e strategia go-to-market.",
  'onboard.s4.title': "Pronto quando lo sei tu",
  'onboard.s4.body': "Registrati e ottieni il tuo primo verdetto in meno di un minuto.",
  'builderReport.title': "Creazione del tuo Builder Report",
  'builderReport.subtitle': "Analisi completa + briefing per sviluppatori — scaricato in PDF quando pronto.",
  'builderReport.idea': "La tua idea",
  'builderReport.ideaPlaceholder': "Descrivi la tua idea di business (oppure lascia vuoto per usare l'ultima idea discussa)…",
  'builderReport.cta': "Genera report",
  'builderReport.credits': "crediti",
  'builderReport.deductedNow': "Addebitato al completamento",
  'builderReport.dontClose': "Non chiudere questa finestra — la generazione può richiedere 30-90 secondi.",
  'builderReport.done': "PDF scaricato — controlla la cartella download.",
  'builderReport.failed': "Generazione fallita",
  'builderReport.close': "Chiudi",
  'builderReport.cancel': "Annulla",
  'builderReport.running': "In generazione…",
  'builderReport.retry': "Riprova",
  'builderReport.unknownError': "Generazione fallita. I tuoi crediti dovrebbero essere rimborsati.",
  'builderReport.signInRequired': "Devi essere connesso per generare un report.",
  'builderReport.ideaRequired': "Descrivi la tua idea per dare all'IA qualcosa da analizzare.",
  'builderReport.fromChat': "Dalla tua conversazione attuale",
  'builderReport.noIdeaDetected': "Useremo l'idea di cui abbiamo discusso.",
  'builderReport.contextHint': "L'IA userà tutto questo chat — non inventerà nuove idee.",
  'builderReport.step.core': "Generazione analisi principale",
  'builderReport.step.market': "Aggiunta analisi di mercato estesa",
  'builderReport.step.tech': "Aggiunta architettura tecnica",
  'builderReport.step.financials': "Aggiunta modelli finanziari",
  'builderReport.step.compet': "Aggiunta intelligence competitiva",
  'builderReport.step.gtm': "Aggiunta strategia go-to-market",
  'builderReport.step.deepdive': "Aggiunta analisi settoriale approfondita",
  'builderReport.step.pdf': "Compilazione del PDF…",
  'briefing.title': "Creazione del briefing per sviluppatori",
  'briefing.subtitle': "Briefing tecnico in 11 sezioni — scaricato in PDF quando pronto.",
  'briefing.ideaPlaceholder': "Descrivi la tua idea di business…",
  'briefing.cta': "Genera briefing",
  'briefing.step.core': "Generazione briefing sviluppatori",
  'briefing.step.pdf': "Compilazione del PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Più crediti + report da 50 pagine",
  'pricing.gold.credits': "12.500 crediti al mese",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Livello massimo + report da 75 pagine",
  'pricing.platinum.credits': "15.000 crediti al mese",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "it" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Solo {{count}} crediti rimasti!",
  'trial.upgradeNow': "Aggiorna ora",
  'trial.upgradeNowArrow': "Aggiorna ora →",
  'trial.creditsExhausted': "Crediti esauriti",
  'trial.upgradeForUnlimited': "Aggiorna per uso illimitato",
  'trial.noCreditsPlaceholder': "Nessun credito disponibile…",
  'hero.badgeHonest': "IA onesta e imparziale",
  'hero.badge60sec': "Verdetto in 60 secondi",
  'hero.badge20Lang': "20+ lingue",
  'hero.widget.label': "Verdetto sull'idea",
  'hero.widget.passed': "APPROVATO",
  'hero.widget.demoIdea': "Tutor IA per studenti di medicina",
  'hero.widget.market': "Mercato",
  'hero.widget.demand': "Domanda",
  'hero.widget.competition': "Concorrenza",
  'hero.widget.verdictReady': "Verdetto pronto · 47 sec",
  'hero.widget.riskFlagged': "Rischio segnalato",
  'hero.widget.crowdedMarket': "Mercato saturo · 4 attori",
  'hero.widget.suggestedPivot': "Pivot suggerito",
  'hero.widget.nicheBySpecialty': "Nicchia per specialità",
  'hero.widget.feasibilityGain': "+38% di fattibilità",
  'hero.widget.analysisDone': "Analisi completata",
  'hero.widget.metrics56': "5 su 6 metriche",
  'hero.stats.verdictSpeed': "Velocità del verdetto",
  'cta.badge': "Verdetto in 60 secondi",
  'cta.subtitleEnd': "senza indovinare.",
  'cta.signinPrompt': "Hai già un account? Accedi",
  'cta.trustTrial': "Prova gratuita di 7 giorni",
  'cta.trustNoCard': "Nessuna carta richiesta",
  'cta.trustCancel': "Cancella quando vuoi",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Modalità chiara",
  'footer.darkMode': "Modalità scura",
  'footer.sectionProduct': "Prodotto",
  'footer.sectionLegal': "Legale",
  'nav.switchLight': "Passa alla modalità chiara",
  'nav.switchDark': "Passa alla modalità scura",
  'features.badge': "Perché IdeaVerdict",
  'features.mainFeatureLabel': "Titolo",
  'chatError.planRestriction': "Questa funzione richiede un piano superiore.",
  'chatError.creditDeduction': "Pagamento fallito. Riprova.",
  'chatError.aiService': "Servizio IA temporaneamente non disponibile. I crediti non sono stati addebitati. Riprova.",
  'chatError.parseError': "Formato di risposta inatteso. Riprova.",
  'chatError.sessionExpired': "La tua sessione è scaduta. Accedi di nuovo.",
  'chatError.timeout': "La richiesta è stata troppo lunga. Riprova.",
  'chatError.generic': "Impossibile ottenere una risposta. Riprova.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "it" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report da 25 pagine",
  'pricing.gold.report': "Builder Report da 50 pagine",
  'pricing.platinum.report': "Builder Report da 75 pagine",
  'auth.bestValue': "Miglior valore",
  'auth.elite': "Élite",
  'builderReport.friendlyError': "Non siamo riusciti a completare il tuo report questa volta. I crediti non sono stati addebitati — riprova tra un momento.",
  'builderReport.persistHint': "Se il problema persiste, contatta support@ideaverdict.ai.",
};
